"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MatchLineupFieldFullPitchProps {
  children: React.ReactNode;
}

/**
 * Horizontal full football pitch with field markings
 * Used for desktop lineup display showing both teams
 */
export const MatchLineupFieldFullPitch: React.FC<MatchLineupFieldFullPitchProps> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="absolute inset-0 w-full h-full" viewBox="0 0 105 68" preserveAspectRatio="none"><rect x="4" y="4" width="97" height="60" fill="none" stroke="white" strokeWidth="0.5" /><line x1="52.5" y1="4" x2="52.5" y2="64" stroke="white" strokeWidth="0.5" /><circle cx="52.5" cy="34" r="9.15" fill="none" stroke="white" strokeWidth="0.5" /><circle cx="52.5" cy="34" r="0.5" fill="white" /><rect x="4" y="13.5" width="16.5" height="41" fill="none" stroke="white" strokeWidth="0.5" /><rect x="4" y="24.5" width="5.5" height="19" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 20.5 25.5 A 9.15 9.15 0 0 1 20.5 42.5" fill="none" stroke="white" strokeWidth="0.5" /><circle cx="16" cy="34" r="0.5" fill="white" /><rect x="84.5" y="13.5" width="16.5" height="41" fill="none" stroke="white" strokeWidth="0.5" /><rect x="95.5" y="24.5" width="5.5" height="19" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 84.5 25.5 A 9.15 9.15 0 0 0 84.5 42.5" fill="none" stroke="white" strokeWidth="0.5" /><circle cx="89" cy="34" r="0.5" fill="white" /><path d="M 5.5 4 A 1.5 1.5 0 0 1 4 5.5" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 4 62.5 A 1.5 1.5 0 0 1 5.5 64" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 99.5 4 A 1.5 1.5 0 0 0 101 5.5" fill="none" stroke="white" strokeWidth="0.5" /><path d="M 101 62.5 A 1.5 1.5 0 0 0 99.5 64" fill="none" stroke="white" strokeWidth="0.5" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="relative w-full aspect-105/68 bg-green-600 rounded-lg overflow-hidden">{t1}<div className="absolute inset-0">{children}</div></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};